<template>
<div class="chapter">
<div class="inner_page">
<p class="right" id="tp"><span class="big1"><strong>Diana the Huntress</strong></span><br/><br/></p>
<p class="right">The Six Sisters: 5<br/><br/><br/><br/><br/><br/><br/><br/></p>
<p class="right">M.C. Beaton/Marion Chesney</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795310959_epub_tp_r1.vue?07a929d7